/* Cart drawer discount offer. Code/label come from theme settings on the summary node. */
(function () {
  var busy = false;
  var tagIconUrl = '';

  function cartRoot() {
    return document.querySelector('.rc90');
  }

  function summaryEl() {
    return document.querySelector('[data-hfb-068-summary]');
  }

  function offerCode() {
    var root = summaryEl();
    return String((root && root.getAttribute('data-code')) || 'HFB15').toUpperCase();
  }

  function offerLabel() {
    var root = summaryEl();
    return (root && root.getAttribute('data-code-label')) || '15OFF';
  }

  function formatMoney(cents) {
    var cart = window.robustCart;
    if (cart && typeof cart.formatMoney === 'function') {
      return cart.formatMoney(cents);
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format((Number(cents) || 0) / 100);
  }

  function addUnique(list, seen, code) {
    if (!code) return;
    var key = String(code).toUpperCase();
    if (seen[key]) return;
    seen[key] = true;
    list.push(String(code));
  }

  function appliedCodes(cart) {
    var codes = [];
    var seen = {};
    if (!cart || !Array.isArray(cart.discount_codes)) return codes;
    cart.discount_codes.forEach(function (entry) {
      if (entry && entry.applicable !== false) addUnique(codes, seen, entry.code);
    });
    return codes;
  }

  function isMixMatchTitle(title) {
    var value = String(title || '')
      .replace(/&amp;/gi, '&')
      .replace(/\s+/g, ' ')
      .toLowerCase();
    return value.indexOf('mix') !== -1 && value.indexOf('match') !== -1;
  }

  function mixMatchTitles(cart) {
    var titles = [];
    var seen = {};
    if (!cart || !Array.isArray(cart.items)) return titles;
    cart.items.forEach(function (item) {
      if (Array.isArray(item.discounts)) {
        item.discounts.forEach(function (entry) {
          if (entry && isMixMatchTitle(entry.title)) addUnique(titles, seen, entry.title);
        });
      }
      if (!Array.isArray(item.line_level_discount_allocations)) return;
      item.line_level_discount_allocations.forEach(function (allocation) {
        var title = allocation && allocation.discount_application && allocation.discount_application.title;
        if (isMixMatchTitle(title)) addUnique(titles, seen, title);
      });
    });
    return titles;
  }

  function hasMixMatch(cart) {
    return mixMatchTitles(cart).length > 0;
  }

  function visibleTags(cart) {
    var tags = [];
    var seen = {};
    appliedCodes(cart).forEach(function (code) {
      addUnique(tags, seen, tagLabel(code));
    });
    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (app) {
        if (!app || !app.title) return;
        addUnique(tags, seen, tagLabel(app.title));
      });
    }
    mixMatchTitles(cart).forEach(function (title) {
      addUnique(tags, seen, title);
    });
    return tags;
  }

  function hasCode(cart, code) {
    var target = String(code).toUpperCase();
    if (appliedCodes(cart).some(function (item) {
      return String(item).toUpperCase() === target;
    })) return true;
    if (!cart || !Array.isArray(cart.cart_level_discount_applications)) return false;
    return cart.cart_level_discount_applications.some(function (app) {
      return app && String(app.title || '').toUpperCase() === target;
    });
  }

  function tagLabel(code) {
    return String(code).toUpperCase() === offerCode() ? offerLabel() : code;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function showConflict(show) {
    var root = summaryEl();
    var message = root && root.querySelector('[data-hfb-068-conflict]');
    if (!message) return;
    message.hidden = !show;
    if (show) message.removeAttribute('hidden');
  }

  function blockMixMatchOffer() {
    var toggle = document.querySelector('[data-hfb-068-toggle]');
    if (toggle) {
      toggle.checked = false;
      var offer = toggle.closest('.hfb-068-offer');
      if (offer) offer.classList.remove('is-checked');
    }
    showConflict(true);
  }

  function offerWasRejected(cart) {
    var code = offerCode();
    if (!cart || !Array.isArray(cart.discount_codes)) return false;
    return cart.discount_codes.some(function (entry) {
      return entry && String(entry.code || '').toUpperCase() === code && entry.applicable === false;
    });
  }

  function clearRejectedOffer(cart) {
    if (!offerWasRejected(cart)) return Promise.resolve(cart);
    var codes = appliedCodes(cart).filter(function (item) {
      return String(item).toUpperCase() !== offerCode();
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (res) {
      if (!res.ok) return cart;
      return res.json();
    }).catch(function () {
      return cart;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('cart fetch failed');
      return res.json();
    });
  }

  function updateDiscount(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (res) {
      if (res.ok) return res.json();
      return fetch('/discount/' + encodeURIComponent(offerCode()), {
        credentials: 'same-origin',
        redirect: 'manual'
      }).then(function () {
        return fetchCart();
      });
    });
  }

  function renderTags(root, codes) {
    var wrap = root.querySelector('[data-hfb-068-tags]');
    if (!wrap) return;
    var tagSrc = wrap.querySelector('.hfb-068-tag__icon img');
    tagIconUrl = wrap.getAttribute('data-hfb-068-tag-icon') ||
      (tagSrc ? tagSrc.getAttribute('src') : '') ||
      tagIconUrl;
    if (tagIconUrl) wrap.setAttribute('data-hfb-068-tag-icon', tagIconUrl);
    var iconUrl = tagIconUrl;
    wrap.innerHTML = codes.map(function (code) {
      return (
        '<span class="hfb-068-tag">' +
          '<span class="hfb-068-tag__icon" aria-hidden="true">' +
            '<img src="' + iconUrl + '" alt="" width="13" height="13">' +
          '</span>' +
          '<span class="hfb-068-tag__label">' + escapeHtml(tagLabel(code)) + '</span>' +
        '</span>'
      );
    }).join('');
  }

  function syncSummary(cart) {
    var root = summaryEl();
    if (!root || !cart) return;

    var toggle = root.querySelector('[data-hfb-068-toggle]');
    var applied = hasCode(cart, offerCode());
    if (toggle) {
      toggle.checked = applied;
      toggle.closest('.hfb-068-offer')?.classList.toggle('is-checked', applied);
    }

    var discountTotal = Number(cart.total_discount || cart.total_discounts || 0);
    var discounts = root.querySelector('[data-hfb-068-discounts]');
    var discountValue = root.querySelector('[data-hfb-068-discount-value]');
    if (discounts) {
      if (discountTotal > 0) {
        discounts.hidden = false;
        discounts.removeAttribute('hidden');
        if (discountValue) discountValue.textContent = '-' + formatMoney(discountTotal).replace(/^-/, '');
      } else {
        discounts.hidden = true;
      }
    }

    if (!hasMixMatch(cart)) showConflict(false);
    renderTags(root, visibleTags(cart));

    var subtotal = root.querySelector('[data-hfb-068-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    var savingCents = cartSavingCents(cart);
    var savingRow = root.querySelector('[data-hfb-068-saving]');
    var savingValue = root.querySelector('[data-hfb-068-saving-value]');
    if (savingRow) {
      if (savingCents > 0) {
        savingRow.hidden = false;
        savingRow.removeAttribute('hidden');
        if (savingValue) savingValue.textContent = formatMoney(savingCents);
      } else {
        savingRow.hidden = true;
      }
    }
  }

  function cartSavingCents(cart) {
    var compareTotal = 0;
    (cart.items || []).forEach(function (item) {
      var qty = Number(item.quantity) || 1;
      var itemEl =
        document.querySelector('.rc90-item[data-line-item-key="' + item.key + '"]') ||
        document.querySelector('.rc90-item[data-item-id="' + item.id + '"]');
      var stored = parseInt((itemEl && itemEl.dataset.compareUnitPrice) || '0', 10) || 0;
      var alloc = Number(item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) || 0;
      var originalUnit = Number(item.original_price) || 0;
      var originalLine = Number(item.original_line_price) || 0;
      compareTotal += Math.max(originalLine, Math.max(stored, alloc, originalUnit) * qty);
    });
    var current = Number(cart.total_price) || 0;
    var discounts = Number(cart.total_discount || cart.total_discounts || 0);
    return Math.max(0, compareTotal - current, discounts);
  }

  function cachedCart() {
    var jsonEl = document.querySelector('.robust-cart-json');
    if (!jsonEl) return {};
    try {
      return JSON.parse(jsonEl.getAttribute('data-cart-json') || '{}');
    } catch (err) {
      return {};
    }
  }

  function publishCart(cart) {
    syncSummary(cart);
    if (window.robustCart && typeof window.robustCart.syncCartFromJson === 'function') {
      window.robustCart.syncCartFromJson(cart);
    }
  }

  function applyToggle(checked) {
    if (busy) return Promise.resolve();
    if (!checked) showConflict(false);
    if (checked && hasMixMatch(cachedCart())) {
      blockMixMatchOffer();
      return Promise.resolve();
    }

    busy = true;
    var offer = document.querySelector('.hfb-068-offer');
    if (offer) offer.classList.add('is-busy');

    var code = offerCode();
    var codes = appliedCodes(cachedCart()).filter(function (item) {
      return String(item).toUpperCase() !== code;
    });
    if (checked) codes.push(code);

    return updateDiscount(codes)
      .then(function (cart) {
        if (!cart || typeof cart !== 'object') return;
        if (checked && hasMixMatch(cart) && !hasCode(cart, offerCode())) {
          showConflict(true);
          return clearRejectedOffer(cart).then(function (nextCart) {
            publishCart(nextCart || cart);
          });
        }
        showConflict(false);
        publishCart(cart);
      })
      .catch(function () {
        var toggle = document.querySelector('[data-hfb-068-toggle]');
        if (toggle) {
          toggle.checked = !checked;
          toggle.closest('.hfb-068-offer')?.classList.toggle('is-checked', !checked);
        }
      })
      .then(function () {
        busy = false;
        if (offer) offer.classList.remove('is-busy');
      });
  }

  function onClick(e) {
    var offer = e.target.closest('.hfb-068-offer');
    var root = summaryEl();
    if (!offer || !root || !root.contains(offer)) return;
    var toggle = offer.querySelector('[data-hfb-068-toggle]');
    if (!toggle || toggle.checked) return;
    if (!hasMixMatch(cachedCart())) return;
    e.preventDefault();
    blockMixMatchOffer();
  }

  function onChange(e) {
    var toggle = e.target.closest('[data-hfb-068-toggle]');
    if (!toggle || !summaryEl()) return;
    applyToggle(toggle.checked);
  }

  window.hfb068SyncCart = function (cart) {
    if (!summaryEl()) return;
    syncSummary(cart);
  };

  function bind() {
    var root = cartRoot();
    if (!root || root.dataset.hfb068Bound) return;
    root.dataset.hfb068Bound = 'true';
    root.addEventListener('click', onClick, true);
    root.addEventListener('change', onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
